import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PaymentSlipResponseDTO } from '../../interfaces/payment-slips.interface';
import { IPaginatedResponse } from '../../interfaces/api/responses.interface';

@Injectable({
  providedIn: 'root',
})
export class SolicitudeService {
  private apiUrl = `${environment.apiUrl}/solicitudes`;

  constructor(private http: HttpClient) {}

  postSolicitudesByCompany(
    filter: Record<string, unknown>
  ): Observable<IPaginatedResponse<PaymentSlipResponseDTO>> {
    return this.http.post<IPaginatedResponse<PaymentSlipResponseDTO>>(
      this.apiUrl + '/listSolicitudeByEmployee',
      filter
    );
  }

  getDetailSolicitudeByDetailSolicitudeId(id: number): Observable<any> {
    return this.http.get<any>(
      `${this.apiUrl}/detailSolicitudeByDetailSolicitudeId/${id}`
    );
  }

  postUpdateStateSolicitudes(formData: FormData): Observable<any> {
    return this.http.post<any>(this.apiUrl + '/changeStateSolicitude', formData);
  }

  postGeneratePDF(data: any): Observable<any> {
    return this.http.post<any>(this.apiUrl + '/generatorPdf', data);
  }

  deleteSolicitude(
    solicitudeId: number,
    typeSolicitudeId: number
  ): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/deleteSolicitude/${solicitudeId}/${typeSolicitudeId}`
    );
  }
}
